import { render, staticRenderFns } from "./ForgotPasswordCompany.vue?vue&type=template&id=a52a6b1a&scoped=true"
import script from "./ForgotPasswordCompany.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCompany.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=a52a6b1a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52a6b1a",
  null
  
)

export default component.exports